import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../../../components/user/footer/Footer";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import "../../../assets/css/user/payment/PaymentStatus.css";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [message, setMessage] = useState("Payment cancel ho gayi.");

  useEffect(() => {
    axios
      .get(`${baseUrl}/customer/orders/payment-cancel`)
      .then((res) => {
        if (res.data.message) {
          setMessage(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="payment-status-page">
      <Navbar />
      <Container>
        <div className="payment-status-box cancel-box">
          <div className="status-icon cancel-icon">
            <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="38" stroke="#ef4444" strokeWidth="4" />
              <path
                d="M28 28L52 52M52 28L28 52"
                stroke="#ef4444"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h1 className="status-title">Payment Cancel Ho Gaya</h1>
          <p className="status-msg">{message}</p>
          <p className="status-msg">Aapke cart items abhi bhi saved hain.</p>
          <div className="status-actions">
            <button className="btn-primary-action" onClick={() => navigate("/cart")}>
              Cart Par Wapas Jaein
            </button>
            <button className="btn-secondary-action" onClick={() => navigate("/")}>
              Home Jaein
            </button>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
}